import React from 'react'
import useFlowStore from '../../components/store/flowStore';

export default function MuteButton() {
  const { toggleBackgroundMusicMuted } = useFlowStore();

  return (
    <svg onClick={toggleBackgroundMusicMuted} className="muteButton" width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="17.5" cy="17.5" r="17" stroke="black"/>
    <path d="M11.1992 13.9992L11.1992 20.9992M19.5992 13.9992L19.5992 20.9992M15.3992 11.1992L15.3992 23.7992M23.7992 11.1992V23.7992" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
